import { Button, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles((theme: any) => ({
  root: {
    '& [class*="icon-"]': {
      fontSize: "1.8rem",
      marginRight: 12,
      [theme.breakpoints.down("sm")]: {
        color: "#fff"
      }
    },
    backgroundColor: "#ffffff",
    boxShadow: "0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)",
    color: "#707070",
    justifyContent: "flex-start" as "flex-start",
    lineHeight: "3.6rem",
    padding: "0 14px",
    textTransform: "initial" as "initial",
    width: "157px",
    [theme.breakpoints.down("sm")]: {
      backgroundColor: "#4a90e2",
      fontSize: 12,
      height: 36,
      minWidth: 40,
      padding: "0 10px",
      width: 40
    }
  }
}));

interface IOwnProps {
  children: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const InstructionsButton = ({ onClick, children }: IOwnProps) => {
  const classes = useStyles();
  return (
    <Button className={classes.root} onClick={onClick}>
      {children}
    </Button>
  );
};

export default React.memo(InstructionsButton);
